import styled from 'styled-components/native';
import Feather from 'react-native-vector-icons/Feather';
import {RFValue} from 'react-native-responsive-fontsize';

import {css} from 'styled-components/native';

import { View } from 'react-native';

export const Container = styled(View)`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
  padding: 0;
`;

export const Content = styled.View`
  padding: 0 24px;
  flex: 1;
  
`;

export const Section = styled.View`
  flex: 1;
`;

export const SectionTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
  margin: 0 24px;
`;

export const FilterOptions = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: ${RFValue(12)}px;
`;

export const Filters = styled.TouchableOpacity`
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
`;

export const FilterTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.blue};
  font-family: ${({theme}) => theme.fonts.medium};
  margin-bottom: ${RFValue(12)}px;
`;

//@ts-ignore
export const StationsList = styled.FlatList`
  margin: 0 -24px;
  flex:1;
  margin-top: ${RFValue(12)}px;
`;

export const LocationList = styled.ScrollView`

`;

export const LocationContainer = styled.View`
  flex-direction: row;
`;

export const Icon = styled(Feather)`
  margin-left: ${RFValue(4)}px;
`;

export const LocationPill = styled.Pressable<{selected: boolean}>`
  padding: ${RFValue(6)}px;
  padding-left: ${RFValue(8)}px;
  border-radius: ${RFValue(8)}px;
  flex: 1;
  border-width: ${RFValue(1)}px;
  border-color: ${({theme, selected}) =>
    selected ? theme.colors.blue : theme.colors.border};
  background-color: ${({selected}) => (selected ? '#68ccde' : 'transparent')};
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const LocationPillText = styled.Text<{selected: boolean}>`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(10)}px;
  ${({selected}) =>
    selected &&
    css`
      color: ${({theme}) => theme.colors.purple_2_shadow_white};
    `}
`;

export const LocationSeparator = styled.View`
  width: ${RFValue(12)}px;
`;
